import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="How to play" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Guess the word in 7 tries. All valid words are in the{' '}
        <a href="https://www.njamed.com/">Bininj Kunwok dictionary</a>, although
        some might be conjugated! After each guess, the color of the tiles will
        change to show how close your guess was to the word. Unlike the other
        word game, we allow you to input non-words. This is because we don't
        have a comprehensive list of words to check against yet.
      </p>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        When the game is over, you'll see the definition of the word!
      </p>

      <div className="mb-1 mt-4 flex justify-center">
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="A"
          status="correct"
        />
        <Cell value="D" isCompleted={true} />
        <Cell value="J" isCompleted={true} />
        <Cell value="U" isCompleted={true} />
        <Cell value="H" isCompleted={true} />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter A is in the word and in the correct spot.
      </p>

      <div className="mb-1 mt-4 flex justify-center">
        <Cell value="K" isCompleted={true} />
        <Cell value="I" isCompleted={true} />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="N"
          status="present"
        />
        <Cell value="G" isCompleted={true} />
        <Cell value="A" isCompleted={true} />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter N is in the word but in the wrong spot.
      </p>

      <div className="mb-1 mt-4 flex justify-center">
        <Cell value="Y" isCompleted={true} />
        <Cell value="I" isCompleted={true} />
        <Cell value="B" isCompleted={true} />
        <Cell isRevealing={true} isCompleted={true} value="O" status="absent" />
        <Cell value="M" isCompleted={true} />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter O is not in the word in any spot.
      </p>

      <p className="mt-6 text-sm italic text-gray-500 dark:text-gray-300">
        By the{' '}
        <a
          href="https://bininjkunwok.org.au/"
          style={{ textDecoration: 'underline' }}
        >
          Bininj Kunwok Regional Language Centre.
        </a>
      </p>
    </BaseModal>
  )
}
